var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var CheckmarkSquare = function CheckmarkSquare(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm13.3 3.6a1 1 0 1 0-1.6-1.2l-3.741 4.988-1.69-2.028a1 1 0 1 0-1.537 1.28l1.69 2.029a2 2 0 0 0 3.137-.08L16.3 9.6Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default CheckmarkSquare;